import React from "react";
import { DialogTitle, DialogContent, DialogActions, Button, Box, IconButton, Typography, } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const ConfirmDialog = ({ handleClose, handleDeleteRow, item, title, handleDeleteBoth }) => {
    return (
        <>
            <div className="ConfirmDialog">
                <DialogTitle>Confirm the action</DialogTitle>
                <Box position="absolute" top={0} right={0}>
                    <IconButton>
                        <Close onClick={handleClose} style={{ fill: "white" }} />
                    </IconButton>
                </Box>
                <DialogContent>
                    <Typography>{title ? title : "Do you really want to delete this record?"}</Typography>
                    <span style={{ fontWeight: "500", background: "#ffff96" }}>Note: Clicking on "Delete Utilization & Op History" will delete the selected entries from Utilization and Operation history.</span>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="contained" onClick={handleClose}>
                        CANCEL
                    </Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                            handleDeleteRow(item);
                            handleClose();
                        }}
                    >
                        DELETE UTILIZATION
                    </Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                            handleDeleteBoth(item)
                            handleClose();
                        }}
                    >
                        DELETE Utilization & Op History
                    </Button>
                </DialogActions>
            </div>
        </>
    );
};
export default ConfirmDialog